export default __webpack_public_path__ + "static/media/f3.5b56043a.jpg";